import _ from "lodash";
import PropTypes from "prop-types";
import React, { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

interface ISearch {
  onSearch: (s: string) => void;
  searchQuery?: string;
  className?: string;
  inputClassName?: string;
}

const Search: FC<ISearch> = ({ onSearch, searchQuery, className, inputClassName }) => {
  const { t } = useTranslation();
  const [query, setSearchQuery] = useState(searchQuery || "");

  const clearSearch = useCallback(
    (e) => {
      e.preventDefault();
      setSearchQuery("");
      onSearch("");
    },
    [onSearch]
  );

  return (
    <div className={`relative ${className}`}>
      <form
        method="post"
        onSubmit={(e) => {
          e.preventDefault();
          onSearch(query);
        }}
      >
        <input
          className={`search-input bg-transparent ${inputClassName}`}
          type="text"
          onChange={(e) => setSearchQuery(e.target.value)}
          value={query}
          placeholder={t("actions.search_placeholder")}
        />

        <button type="submit" className="btn-search text-blue-100" />
        {!_.isEmpty(query) && <button className="btn-clear-search" onClick={clearSearch} />}
      </form>
    </div>
  );
};

Search.propTypes = {
  className: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  searchQuery: PropTypes.string,
  inputClassName: PropTypes.string,
};

Search.defaultProps = {
  searchQuery: "",
  className: "",
};

export default Search;
